import { defineMessages } from '@/hooks/useTranslation';

export default defineMessages({
  header: {
    title: {
      de: 'Microsoft Business Central – ERP',
      en: 'Microsoft Business Central – ERP'
    },
    titleHighlight: {
      de: 'ERP',
      en: 'ERP'
    },
    description: {
      de: 'Optimiere Finanzen, Vertrieb, Einkauf, Lager und mehr – alles in einer integrierten Lösung, die sich Ihrem Unternehmen anpasst.',
      en: 'Optimize finance, sales, purchasing, inventory and more – all in one integrated solution that adapts to your business.'
    },
    details: {
      de: 'Das zentrale ERP-System für zukunftsorientierte KMUs, das mit Ihrem Unternehmen wächst und alle Geschäftsprozesse intelligent vernetzt.',
      en: 'The central ERP system for future-oriented SMEs that grows with your company and intelligently connects all business processes.'
    },
    primaryCTA: {
      de: 'Mehr erfahren',
      en: 'Learn more'
    },
    secondaryCTA: {
      de: 'Beratungsgespräch vereinbaren',
      en: 'Schedule a consultation'
    }
  },
  features: {
    title: {
      de: 'Was kann Microsoft Business Central eigentlich?',
      en: 'What can Microsoft Business Central actually do?'
    },
    subtitle: {
      de: 'Microsoft Business Central ist eine umfassende ERP-Lösung, die speziell für KMU entwickelt wurde und alle wesentlichen Geschäftsprozesse in einem System vereint:',
      en: 'Microsoft Business Central is a comprehensive ERP solution developed specifically for SMEs that combines all essential business processes in one system:'
    },
    items: {
      finance: {
        title: {
          de: 'Finanzmanagement',
          en: 'Financial Management'
        },
        description: {
          de: 'Verwalte Buchhaltung, Cashflow, Budgetierung und Finanzanalysen in Echtzeit – behalte jederzeit den Überblick über Deine finanzielle Situation.',
          en: 'Manage accounting, cash flow, budgeting and financial analysis in real time – always keep track of your financial situation.'
        }
      },
      sales: {
        title: {
          de: 'Vertriebs- und Kundenmanagement',
          en: 'Sales and Customer Management'
        },
        description: {
          de: 'Organisiere den gesamten Vertriebsprozess von der Angebotserstellung bis zum Abschluss und verwalte Kundenbeziehungen, Verkaufschancen und Marketingaktivitäten.',
          en: 'Organize the entire sales process from offer creation to completion and manage customer relationships, sales opportunities and marketing activities.'
        }
      },
      procurement: {
        title: {
          de: 'Einkauf und Lieferkettenmanagement',
          en: 'Procurement and Supply Chain Management'
        },
        description: {
          de: 'Optimiere den Einkaufsprozess, steuere Bestellungen, Lieferantenbeziehungen und Lagerbestände für kosteneffiziente und flexible Prozesse.',
          en: 'Optimize the purchasing process, control orders, supplier relationships and inventory for cost-efficient and flexible processes.'
        }
      },
      inventory: {
        title: {
          de: 'Lager- und Bestandsverwaltung',
          en: 'Warehouse and Inventory Management'
        },
        description: {
          de: 'Erhalte eine transparente Übersicht über Lagerbestände, steuere Wareneingänge und -ausgänge effizient und minimiere Überbestände oder Engpässe.',
          en: 'Get a transparent overview of inventory, efficiently control incoming and outgoing goods and minimize excess inventory or bottlenecks.'
        }
      },
      project: {
        title: {
          de: 'Projektmanagement',
          en: 'Project Management'
        },
        description: {
          de: 'Plane, überwache und steuere Projekte mit detaillierten Zeitplänen, Ressourcenplanung und Kostenkontrolle – alles aus einer Hand.',
          en: 'Plan, monitor and control projects with detailed schedules, resource planning and cost control – all from a single source.'
        }
      },
      service: {
        title: {
          de: 'Service und Support',
          en: 'Service and Support'
        },
        description: {
          de: 'Verbessere Deine Servicequalität durch integrierte Service-Management-Funktionen für optimale Bearbeitung von Kundenanfragen und Serviceaufträgen.',
          en: 'Improve your service quality through integrated service management functions for optimal processing of customer inquiries and service orders.'
        }
      },
      bi: {
        title: {
          de: 'Business Intelligence und Reporting',
          en: 'Business Intelligence and Reporting'
        },
        description: {
          de: 'Nutze integrierte Analysen und Dashboards für fundierte Entscheidungen und strategische Weichenstellungen auf Basis von Echtzeitdaten.',
          en: 'Use integrated analyses and dashboards for informed decisions and strategic positioning based on real-time data.'
        }
      },
      integration: {
        title: {
          de: 'Integration und Automatisierung',
          en: 'Integration and Automation'
        },
        description: {
          de: 'Profitiere von nahtloser Integration in das Microsoft-Ökosystem (Office 365, Power BI, Dynamics 365) sowie von automatisierten Prozessen.',
          en: 'Benefit from seamless integration into the Microsoft ecosystem (Office 365, Power BI, Dynamics 365) as well as automated processes.'
        }
      }
    }
  }
}); 